import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { adminApi, client } from '../lib/api';
import { PageHeader, Loading, ErrorBox, Badge } from '../components/ui';

export function LiveOrdersPage() {
  const qc = useQueryClient();
  const board = useQuery({ queryKey: ['admin-board'], queryFn: () => adminApi.board() });

  useEffect(() => {
    const unsub = client.sseStream('/v1/admin/stream', () => {
      qc.invalidateQueries({ queryKey: ['admin-board'] });
      qc.invalidateQueries({ queryKey: ['admin-nav-counts'] });
    });
    return unsub;
  }, [qc]);

  if (board.isLoading) return <Loading />;
  if (board.error) return <ErrorBox error={board.error} />;

  const columns = (board.data as any)?.columns ?? [];

  return (
    <div>
      <PageHeader title="Live orders" subtitle="Every order moving through the pipeline, updating in real time" />
      <div className="flex gap-4 overflow-x-auto pb-4">
        {columns.map((col: any) => (
          <div key={col.stage} className="w-[260px] shrink-0">
            <div className="flex items-center justify-between mb-2 px-1">
              <span className="font-semibold text-sm" style={{ color: 'var(--text-heading)' }}>{col.title}</span>
              <Badge tone="neutral">{col.count}</Badge>
            </div>
            <div className="space-y-2">
              {col.cards?.length ? col.cards.map((card: any) => (
                <div key={card.id} className="card p-3">
                  <div className="flex items-center justify-between text-xs mb-1">
                    <span className="font-semibold" style={{ color: 'var(--text-heading)' }}>{card.id}</span>
                    <span style={{ color: card.timer?.tone === 'danger' ? 'var(--danger)' : 'var(--text-faint)' }}>{card.timer?.since}</span>
                  </div>
                  <div className="text-sm font-medium mb-0.5" style={{ color: 'var(--text-heading)' }}>{card.store}</div>
                  <div className="flex items-center justify-between text-xs mb-2" style={{ color: 'var(--text-muted)' }}>
                    <span>{card.customerFirstName}</span>
                    <span className="font-semibold">{card.amount?.formatted}</span>
                  </div>
                  <div className="flex gap-1 flex-wrap">
                    {(card.badges ?? []).map((b: any, i: number) => (
                      <Badge key={i} tone={b.tone ?? 'neutral'}>{b.text ?? b}</Badge>
                    ))}
                  </div>
                </div>
              )) : (
                <div className="text-xs text-center py-6" style={{ color: 'var(--text-faint)' }}>No orders</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
